import styled from 'styled-components';

export const SearchWrapper = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
`;

export const SearchIconSlot = styled.span`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  padding-left: ${({ theme }) => theme.landingSpacing.sm};
  color: ${({ theme }) => theme.landing.textMuted};
  pointer-events: none;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 36px;
  padding: 0 40px;
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  border: 1px solid ${({ theme }) => theme.landing.inputBorder};
  background: ${({ theme }) => theme.landing.inputBg};
  color: ${({ theme }) => theme.landing.text};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.normal};
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &::placeholder {
    color: ${({ theme }) => theme.landing.textMuted};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.landing.buttonBg};
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  }
`;

export const ShortcutHint = styled.kbd`
  position: absolute;
  top: 50%;
  right: ${({ theme }) => theme.landingSpacing.sm};
  transform: translateY(-50%);
  padding: 2px 6px;
  border-radius: ${({ theme }) => theme.landingBorderRadius.sm};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  font-family: ${({ theme }) => theme.fonts.primary};
  background: ${({ theme }) => theme.landing.iconBg};
  color: ${({ theme }) => theme.landing.textSecondary};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  pointer-events: none;
`;
